import { Inject, Injectable } from '@angular/core'
import { Seat } from 'src/app/shared/models'
import { APP_CONFIG } from '../../configuration/ticket-management-portal-configuration'
import { TicketManagementPortalConfiguration } from '../../configuration/ticket-management-portal-configuration.model'
import { UserService } from '../../services'
import { ConfigurationService } from '../../services/configuration.service'
import { BuyerTypePirates } from './buyer-type-pirates.model'
import { BuyerTypeRangers } from './buyer-type-rangers.model'
import { FlowControlService } from './flow-control.service'
import { BuyerTypeCardinals } from "./cardinals_buyer_type.model";
@Injectable({
    providedIn: 'root'
})

export class PricingService {
    // Pricing storage
    public seatpricing = {};
    public areapricing = {};
    public maxPrice: {price?: number, price_type?: string} = {};

    private seatsPricingQueue = [];
    private seatsPricingQueueBuffer = [];
    // generic variable to hold the price code name of seats discarded
    // useful when we match the price based on the origin buyer type or something like this
    private priceCodeDiscarded = [];
    // used in pirates where addons depends on initial price code (buyer type id in our case)
    private initialPriceCode: string;

    constructor(private configurationService: ConfigurationService, private flowControl: FlowControlService,
                private userService: UserService,
                @Inject(APP_CONFIG) public appConfig: TicketManagementPortalConfiguration) {}

    get pricingQueueLength() {
        return this.seatsPricingQueue.length;
    }

    pricingQueueHash = {};
    // seatsArray are discarded seats
    init(seatsArray: Seat[]) {
        const priceToUse = this.getPriceToUse()
        this.priceCodeDiscarded = [];
        seatsArray.sort((a, b) => a[priceToUse] - b[priceToUse]);
        seatsArray.map(seat => {
          // push price code names to choose or push seat ids
          // this is used when the buyer type depends on the origin price code name
          // or when the buyer type depends on the quantity of seats re
          const priceCodeName = seat.price_code_name ? seat.price_code_name : seat.id;
          this.priceCodeDiscarded.push(priceCodeName);
        });
        this.initialPriceCode = this.userService.getCustomerPlanById(this.flowControl.currentPlan).category;
        this.seatsPricingQueue = seatsArray;
    }

    setMaxPrice(seatsArray) {
      const priceToUse = this.getPriceToUse()
        if (seatsArray && seatsArray.length) {
            seatsArray.sort((a, b) => a[priceToUse] - b[priceToUse]);
            const maxPriceSeat = seatsArray.pop();
            this.maxPrice = {price: maxPriceSeat[priceToUse], price_type: maxPriceSeat.price_type_name};
        }
    }

   getPriceToUse() {
    const isTaxesBreakdownEnabled = this.appConfig.rules.isTaxesBreakdownEnabled
    return isTaxesBreakdownEnabled ? 'all_in_price' : 'price'
  }

    getSeatPrice(seatId) {
      // method used only on modals and to showcase the price. Is is taxesbreakdown enabled we show the
      // all in price, we can refactor this method to return the priceData as in setpricing and calculatePricing
      // if we need both at some point
      const priceData = this.calculatePricing(seatId, false);
      return priceData[this.getPriceToUse()];
    }

    setPricing(seatId) {
        return this.calculatePricing(seatId, true);
    }

    calculatePricing(seatId, setPrice) {
        // https://mmcbcn.atlassian.net/browse/IT-2685
        if (this.configurationService.client === 'minnesotatwins') {          
          if (this.appConfig['thrivent_club_price_types'].includes(this.seatpricing[seatId].price_type)) {
            const customerPlan = this.userService.getCustomerPlanById(this.flowControl.currentPlan);
            let hasThrivent = false;
            // we get if previously has a thrivent
            for (const seat of customerPlan.customer_plan_seats) {
              if (this.appConfig['thrivent_club_sections'].includes(seat['section'])) {
                hasThrivent = true;
              }
            }
            const prices = this.seatpricing[seatId].all_prices.sort((n1, n2) => n1.price - n2.price);
            const relocationPrice = prices[0];
            const addonPrice = prices[1];
            let price = addonPrice;
            // we need the tier because on Tier 3 and sectors thrivent 20 we don't get 2 prices (new/renew) only get 1... 
            // if match this... We use the prices[0] --> relocationPrice
            const upgradePlan = this.flowControl.upgradePlan;
            let tier = -1;
            if (!upgradePlan) {                
                tier = this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.tier;                
            }
            else {  
              // if we are upgrading we need to get the origin CustomerPlanIndex
              let originCustomerPlanIndex = null;
              for (let [index, customerPlan] of this.userService.user.plans.entries()){
                  if (customerPlan.id === this.flowControl.currentPlan){
                      originCustomerPlanIndex = index;
                      break;
                  }
              }
              for (const plan of this.userService.user.plans[originCustomerPlanIndex].plan_change_availability){
                  if (plan.id === upgradePlan) {
                    tier = plan.tier
                    break;
                  }
               }
            }
            if (tier == 3){
              price = relocationPrice;
            }

            // if thrivent and in list we apply relocation price
            if (hasThrivent && this.appConfig['thrivent_club_new_buyer_type'].includes(parseInt(this.userService.getUser().username,10)))  {
              price = relocationPrice;
            }
            return price;
          }
        }
        if (this.configurationService.client === 'ladodgers') {
            // https://mmcbcn.atlassian.net/wiki/spaces/IS/pages/140967968/Configuration+for+season+-+LA+Dodgers+-+SMP+IT
            // LA Dodgers use original buyer type to determinate the destination buyer type for current/upgrade plan.
            // Only for Dodgers --> the User.plans.customer_plan_seat.price_code_name is used to store the origin buyer type of this customerplan
            const upgradePlan = this.flowControl.upgradePlan;
            let destinationBuyerType = null;
            let originPlanIndex = null;
            for (let [index, plan] of this.userService.user.plans.entries()){
                if (plan.id === this.flowControl.currentPlan)
                originPlanIndex = index;
            }
            try{
                const originBuyerType = this.userService.user.plans[originPlanIndex].customer_plan_seats[0].price_code_name;
                if (!upgradePlan){

                    const tier = this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.tier;
                    destinationBuyerType = this.appConfig['destinationBuyerTypeByTierAndOriginBuyerType'][originBuyerType][tier]
                }
                else{
                    for (const plan of this.userService.user.plans[originPlanIndex].plan_change_availability){
                        if (plan.id === upgradePlan)
                            destinationBuyerType = this.appConfig['destinationBuyerTypeByTierAndOriginBuyerType'][originBuyerType][plan.tier]
                    }
                }
            }
            // LAD may create empty customer plans for a customer in order to can buy multiple times. Then there is no Original Buyer Type and need to get
            // the destination buyer type from this.appConfig['BuyerTypeNewbyTier'][tier]
            catch{
                if (!upgradePlan){
                    const tier = this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.tier;
                    destinationBuyerType = this.appConfig['BuyerTypeNewbyTier'][tier]
                }
                else{
                    for (const plan of this.userService.user.plans[originPlanIndex].plan_change_availability){
                        if (plan.id === upgradePlan)
                            destinationBuyerType = this.appConfig['BuyerTypeNewbyTier'][plan.tier]
                    }
                }
            }
            for (const seat of this.seatpricing[seatId].all_prices){
                if (seat.buyer_type_id === destinationBuyerType)
                    return seat;
            }
        }
        if (this.configurationService.client === 'clevelandguardians') {
          const customerPlan = this.userService.getCustomerPlanById(this.flowControl.currentPlan);
          let priceData = this.seatpricing[seatId].all_prices.find(x => x.buyer_type_type === customerPlan.category);
          // if price not found we'll probably have an error in the backend saying the buyer type candidate is not found
          if (!priceData) {
            console.log('price not found');
            priceData = this.seatpricing[seatId];
          }
          return priceData;
        }
        if (this.configurationService.client === 'pittsburghpirates') {
          // https://mmcbcn.atlassian.net/browse/MMC-13537?focusedCommentId=56881
          // pirates defines destination buyer type based on origin buyer type and destination plan, and distinguish between addon and
          // relocation
          const allPrices = this.seatpricing[seatId].all_prices;
          // tslint:disable-next-line: no-string-literal
          const buyerTypes = this.appConfig['buyer_types'] as BuyerTypePirates;
          // the destination plan is the current plan if we are not upgrading, if we are upgrading is the upgrade plan
          const destinationPlanId = this.flowControl.upgradePlan ? this.flowControl.upgradePlan : this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.id;
          let originBuyerType = this.initialPriceCode;
          // if we don't do this, hover on sections take out price codes from the list and messes results
          if (setPrice) {
            // 1st we try to pop one buyer type
            originBuyerType = this.priceCodeDiscarded.pop();
          } else {
            // hover price get the price available if any if not the initial
            if (originBuyerType.length !== 0) {
              originBuyerType = this.priceCodeDiscarded[this.priceCodeDiscarded.length - 1];
            }
          }
          //  the final origin buyer type is the origin if we have one or the previous saved initial price code
          const finalOriginBuyerType = originBuyerType ? originBuyerType : this.initialPriceCode;
          const destinationBuyerTypeInfo = buyerTypes[finalOriginBuyerType][destinationPlanId];
          let destinationBuyerType = null;
          // if we don't have originBuyerType is because we ran off priceCodeDiscarded hence is addon
          if (!originBuyerType) {
              destinationBuyerType = destinationBuyerTypeInfo.buyer_type_addon;
          } else {
            destinationBuyerType = destinationBuyerTypeInfo.buyer_type_normal;
          }
          if ( setPrice ) {
            console.log('setprice:' + destinationBuyerType);
          } else {
            console.log('hoverprice:' + destinationBuyerType);
          }

          // finally we search in the all prices info the price that is related to this buyer type
          const priceData =  allPrices.find(x => x.buyer_type_id === destinationBuyerType);
          return priceData;
        }
        if (this.configurationService.client === 'padres') {
          // https://mmcbcn.atlassian.net/browse/DEL-74
          // padres are the same as pirates
          // defines destination buyer type based on origin buyer type and destination plan, and distinguish between addon and
          // relocation
          const allPrices = this.seatpricing[seatId].all_prices;
          // tslint:disable-next-line: no-string-literal
          const buyerTypes = this.appConfig['buyer_types'] as BuyerTypePirates;
          // the destination plan is the current plan if we are not upgrading, if we are upgrading is the upgrade plan
          const destinationPlanId = this.flowControl.upgradePlan ? this.flowControl.upgradePlan : this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.id;
          let originBuyerType = this.initialPriceCode;
          // if we don't do this, hover on sections take out price codes from the list and messes results
          if (setPrice) {
            // 1st we try to pop one buyer type
            originBuyerType = this.priceCodeDiscarded.pop();
          } else {
            // hover price get the price available if any if not the initial
            if (originBuyerType.length !== 0) {
              originBuyerType = this.priceCodeDiscarded[this.priceCodeDiscarded.length - 1];
            }
          }
          //  the final origin buyer type is the origin if we have one or the previous saved initial price code
          const finalOriginBuyerType = originBuyerType ? originBuyerType : this.initialPriceCode;
          const destinationBuyerTypeInfo = buyerTypes[finalOriginBuyerType][destinationPlanId];
          let destinationBuyerType = null;
          // if we don't have originBuyerType is because we ran off priceCodeDiscarded hence is addon
          if (!originBuyerType) {
            destinationBuyerType = destinationBuyerTypeInfo.buyer_type_addon;
          } else {
            destinationBuyerType = destinationBuyerTypeInfo.buyer_type_normal;
          }
          if ( setPrice ) {
            console.log('setprice:' + destinationBuyerType);
          } else {
            console.log('hoverprice:' + destinationBuyerType);
          }

          // finally we search in the all prices info the price that is related to this buyer type
          const priceData =  allPrices.find(x => x.buyer_type_id === destinationBuyerType);
          return priceData;
        }
        if (this.configurationService.client === 'washingtonnationals') {
            // Nationals defines destination buyer type based on origin buyer type and destination plan, and distinguish between addon and
            // relocation and same plan and upgrade plan
            // check if we are upgrading plan
            const upgradePlan = this.flowControl.upgradePlan;
            let destinationBuyerType = null;
            // the destination plan is the current plan if we are not upgrading, if we are upgrading is the upgrade plan
            const destinationPlanId = this.flowControl.upgradePlan ? this.flowControl.upgradePlan : this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.id;
            let originBuyerType = this.initialPriceCode;

            const isAddon = this.priceCodeDiscarded.length !== 0? false : true;

            // if we don't do this, hover on sections take out price codes from the list and messes results
            if (setPrice) {
                // 1st we try to pop one buyer type
                originBuyerType = this.priceCodeDiscarded.pop();
            }
            else {
                // hover price get the price available if any if not the initial
                if (this.priceCodeDiscarded.length !== 0) {
                    originBuyerType = this.priceCodeDiscarded[this.priceCodeDiscarded.length - 1];
                }
            }

            if (!upgradePlan) {
                if (isAddon){
                    const tier = this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.tier;
                    destinationBuyerType = this.appConfig['BuyerTypeNewbyTier'][tier]
                }
                else{
                    destinationBuyerType = Number(originBuyerType);
                }
            }
            else{
              // if we are upgrading we need to get the origin CustomerPlanIndex
              let originCustomerPlanIndex = null;
              for (let [index, customerPlan] of this.userService.user.plans.entries()){
                  if (customerPlan.id === this.flowControl.currentPlan){
                      originCustomerPlanIndex = index;
                      break;
                  }
              }
              for (const plan of this.userService.user.plans[originCustomerPlanIndex].plan_change_availability){
                  if (plan.id === upgradePlan) {
                      if (isAddon) destinationBuyerType = this.appConfig['BuyerTypeNewbyTier'][plan.tier];
                      else destinationBuyerType = this.appConfig['destinationBuyerTypeByTierAndOriginBuyerType'][originBuyerType][plan.tier];
                      break;
                  }
                }
              }

            // Get the correct price
            let seat_price = null;
            for (const seat of this.seatpricing[seatId].all_prices){
                if (seat.buyer_type_id === destinationBuyerType)
                    seat_price = seat;
               }
            return seat_price;
        }
        if (this.configurationService.client === 'texasrangers') {
          try {
            // https://mmcbcn.atlassian.net/browse/MMC-14837?focusedCommentId=73163
            // rangers preserves original buyer type id when relocating and upgrading on same tier plan
            // all the addons goes to the same buyer type per plan
            // when changing plans to a higher tier one, all the seats goes to the same buyer type
            // relocation
            const allPrices = this.seatpricing[seatId].all_prices;
            // tslint:disable-next-line: no-string-literal
            const buyerTypes = this.appConfig['buyer_types'] as BuyerTypeRangers;
            // the destination plan is the current plan if we are not upgrading, if we are upgrading is the upgrade plan
            const destinationPlanId = this.flowControl.upgradePlan ? this.flowControl.upgradePlan : this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.id;
            const originCustomerPlan = this.userService.getCustomerPlanById(this.flowControl.currentPlan);
            const addonBuyerType = buyerTypes[destinationPlanId].buyer_type_addon;
            const upgradeBuyerType = buyerTypes[destinationPlanId].buyer_type_upgrade;
            let destinationBuyerType = null;
            let sameTier = true;
            // we asume same tier = true because normal relocations are treated as same tier
            if (originCustomerPlan.plan.id !== destinationPlanId) {
              const destinationTier = originCustomerPlan.plan_change_availability.find(x => x.id === destinationPlanId).tier;
              if (originCustomerPlan.plan.tier !== destinationTier) {
                sameTier = false;
              }
            }
            // if not same tier the destination is the upgrade buyer type for all cases
            if (!sameTier) {
              destinationBuyerType = upgradeBuyerType;
            } else { // normal relocation or same tier relocation
              destinationBuyerType = addonBuyerType;
              // if we don't do this, hover on sections take out price codes from the list and messes results
              if (setPrice) {
                // 1st we try to pop one buyer type
                destinationBuyerType = this.priceCodeDiscarded.pop();
              } else {
                if (this.priceCodeDiscarded.length !== 0) {
                  destinationBuyerType = this.priceCodeDiscarded[this.priceCodeDiscarded.length - 1];
                }
              }
              // if we don't have destination buyer type is because we ran off and we have to use the addon
              if (!destinationBuyerType) {
                destinationBuyerType = addonBuyerType;
              }
            }
            if ( setPrice ) {
              console.log('setprice:' + destinationBuyerType);
            } else {
              console.log('hoverprice:' + destinationBuyerType);
            }

            // finally we search in the all prices info the price that is related to this buyer type
            const priceData =  allPrices.find(x => x.buyer_type_id === parseInt(destinationBuyerType, 10));
            return priceData;
            } catch (e) {
            console.log('buyer type not found');
            return this.seatpricing[seatId];
          }
        }
        if (this.configurationService.client === 'athletics') {
          // https://mmcbcn.atlassian.net/browse/DEL-69?focusedCommentId=95044
          // Athletics want to use origin buyer type as a destination buyer type.
          // All seats from a customer has the same buyer type. If not.... need to change using customer_plan.category
          const customerPlan = this.userService.getCustomerPlanById(this.flowControl.currentPlan);
          let priceData = this.seatpricing[seatId].all_prices.find(x => x.buyer_type_id == customerPlan.category);
          // if price not found we'll probably have an error in the backend saying the buyer type candidate is not found
          if (!priceData) {
            console.log('price not found');
            priceData = this.seatpricing[seatId];
          }
          return priceData;
        }
        if (this.configurationService.client === 'stlouiscardinals') {

          // https://mmcbcn.atlassian.net/browse/MMC-13537?focusedCommentId=56881
          // pirates defines destination buyer type based on origin buyer type and destination plan, and distinguish between addon and
          // relocation
          const allPrices = this.seatpricing[seatId].all_prices;
          // tslint:disable-next-line: no-string-literal
          const buyerTypes = this.appConfig['buyer_types'] as BuyerTypeCardinals;
          // the destination plan is the current plan if we are not upgrading, if we are upgrading is the upgrade plan
          const destinationPlanId = this.flowControl.upgradePlan ? this.flowControl.upgradePlan : this.userService.getCustomerPlanById(this.flowControl.currentPlan).plan.id;
          // if we don't do this, hover on sections take out price codes from the list and messes results
          let seatDiscarded;
          if (setPrice) {
            // 1st we try to pop one buyer type
            seatDiscarded = this.priceCodeDiscarded.pop();
          } else {
            // hover price get the price available if any if not the initial
            if (this.priceCodeDiscarded.length !== 0) {
              seatDiscarded = this.priceCodeDiscarded[this.priceCodeDiscarded.length - 1];
            }
          }
          let destinationBuyerType;
          let type;
          // if we don't have originBuyerType is because we ran off seats hence is addon
          if (!seatDiscarded) {
            type = 'addon';
          } else {
            type = 'default';
          }
          destinationBuyerType = buyerTypes[destinationPlanId][type];
          if ( setPrice ) {
            console.log('setprice:' + destinationBuyerType);
          } else {
            console.log('hoverprice:' + destinationBuyerType);
          }
          // finally we search in the all prices info the price that is related to this buyer type
          const priceData =  allPrices.find(x => x.buyer_type_id === destinationBuyerType);
          return priceData;

        }
        if (this.configurationService.client === 'detroittigers') {
          // Tigers defines destination buyer type based on origin buyer type and destination plan tier. 
          // On relocation uses same as origin buyer type and we uses this.appConfig['buyer_types']. 
          // Also there is a edge case for customers that have multiple origin buyer type. We use then this.appConfig['buyer_type_addon_by_tier_on_multiple_orgin_buyer_type']
          const allPrices = this.seatpricing[seatId].all_prices;          
          let destinationPlanTier = 1;   
          const upgradePlan = this.flowControl.upgradePlan;
          let has_multiple_origin_buyer_types = false;
          if (!upgradePlan) {
            const customer_plan = this.userService.getCustomerPlanById(this.flowControl.currentPlan);
            destinationPlanTier = customer_plan.plan.tier;
            has_multiple_origin_buyer_types = this.hasMultiplePriceCodes(customer_plan.customer_plan_seats)
          }
          else{
              // if we are upgrading we need to get the origin CustomerPlanIndex
              let originCustomerPlanIndex = null;
              for (let [index, customerPlan] of this.userService.user.plans.entries()){
                  if (customerPlan.id === this.flowControl.currentPlan){
                      originCustomerPlanIndex = index;
                      break;
                  }
              }
              has_multiple_origin_buyer_types = this.hasMultiplePriceCodes(this.userService.user.plans[originCustomerPlanIndex].customer_plan_seats)
              for (const plan of this.userService.user.plans[originCustomerPlanIndex].plan_change_availability){
                  if (plan.id === upgradePlan) {
                    destinationPlanTier = plan.tier                     
                      break;
                  }
                }
              }

          let originBuyerType = this.initialPriceCode;
          // if we don't do this, hover on sections take out price codes from the list and messes results
          if (setPrice) {              
            // 1st we try to pop one buyer type
            originBuyerType = this.priceCodeDiscarded.pop();
          } else {
            // hover price get the price available if any if not the initial
            if (originBuyerType.length !== 0) {
              originBuyerType = this.priceCodeDiscarded[this.priceCodeDiscarded.length - 1];
            }
          }
          //  the final origin buyer type is the origin if we have one or the previous saved initial price code
          const finalOriginBuyerType = originBuyerType ? originBuyerType : this.initialPriceCode;
          // tslint:disable-next-line: no-string-literal
          const buyerTypes = this.appConfig['buyer_types'] as BuyerTypePirates;
          const destinationBuyerTypeInfo = buyerTypes[finalOriginBuyerType][destinationPlanTier];
          const multiple_origin_bt_destination_bt_addon = this.appConfig['buyer_type_addon_by_tier_on_multiple_orgin_buyer_type']      
          let destinationBuyerType = null;
          // if we don't have originBuyerType is because we ran off priceCodeDiscarded hence is addon
          if (!originBuyerType) {
            // need to check if customer plan has multiple buyer types
            if (has_multiple_origin_buyer_types){
              destinationBuyerType = multiple_origin_bt_destination_bt_addon[destinationPlanTier];
            }
            else {
              destinationBuyerType = destinationBuyerTypeInfo.buyer_type_addon;
            }
          } else {
            destinationBuyerType = destinationBuyerTypeInfo.buyer_type_normal;
          }
          if ( setPrice ) {
            console.log('setprice:' + destinationBuyerType);
          } else {
            console.log('hoverprice:' + destinationBuyerType);
          }

          // finally we search in the all prices info the price that is related to this buyer type
          const priceData =  allPrices.find(x => x.buyer_type_id === destinationBuyerType);
          return priceData;
        }

        // if none of the previous, we return the seatpricing of the seat that is set to the first of the prices array

        return this.seatpricing[seatId];
    }

    usePrice(seatId) {
        const priceToUse = this.getPriceToUse()
        if (this.seatsPricingQueue.length) {
            const popped = this.seatsPricingQueue.pop();
            const price = popped[priceToUse] ||  popped.price;
            this.pricingQueueHash[seatId] = price;
            this.seatsPricingQueueBuffer.push(popped);
            return price;
        }
    }

    restorePrice(seatId) {
      const priceToUse = this.getPriceToUse()
      console.log("restore");
      this.init(Object.values(this.flowControl.discardedSeats));
      // we recalculate the price and since this object is the same reference pass to ticket component
      // we can change price here, ugly and dangerous but working
      // tslint:disable-next-line:forin
      for (const seat in this.flowControl.Basket) {
        const priceInfo = this.setPricing(seat);
        this.flowControl.Basket[seat].price = priceInfo.price;
        this.flowControl.Basket[seat].all_in_price = priceInfo.all_in_price;
      }
    }

    // We use this function to check if a customer plan has more than 1 price_code_name (usually used as origin buyer type)
    hasMultiplePriceCodes(items: Array<Seat>): boolean {
      if (items.length === 0) {
        return false;
      }

      const firstCode = items[0].price_code_name;

      for (let i = 1; i < items.length; i++) {
        if (items[i].price_code_name !== firstCode) {
          // As soon as we find a different price_code_name, we can return true
          return true;
        }
      }

      // If we reached here, all price_code_name are the same
      return false;
    }

}
